var map = {
	"./ata-exame/routes.ts": 7132,
	"./dashboard/routes.ts": 6773,
	"./exame-aluno/routes.ts": 7313,
	"./exame-turma/routes.ts": 307,
	"./parametrizacao-exames/exame-amparo-rede/routes.ts": 8153,
	"./relatorios-pendencias-exames/routes.ts": 5990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3019;